var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 532 562",
    style: {
      enableBackground: "new 0 0 532 562"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382,90v-4.5c0-23.6-8.3-43.8-25.1-60.5C340.2,8.4,320.1,0,296.5,0h-61c-23.6,0-43.8,8.4-60.5,25 c-16.7,16.7-25,36.9-25,60.5V90H20.5C14.8,90,10,92,6,96c-4,4-6,8.8-6,14.5c0,5.7,2,10.5,6,14.5c4,4,8.8,6,14.5,6H59v345.5 c0,23.6,8.4,43.8,25,60.5c16.7,16.7,36.8,25,60.5,25h118h7h118c23.6,0,43.8-8.4,60.4-25c16.7-16.7,25.1-36.8,25.1-60.5V131h38.5 c5.7,0,10.5-2,14.5-6c4-4,6-8.8,6-14.5c0-5.7-2-10.5-6-14.5c-4-4-8.8-6-14.5-6H382 M341,85.5V90h-71.4c0,0-0.1,0-0.1,0H191v-4.5 c0-12.3,4.4-22.8,13-31.5c8.7-8.7,19.2-13,31.5-13h61c12.3,0,22.8,4.4,31.4,13C336.7,62.8,341,73.2,341,85.5 M113,508 c-8.7-8.7-13-19.2-13-31.5V131h332v345.5c0,12.3-4.3,22.8-13.1,31.5c-8.7,8.7-19.2,13-31.4,13h-118h-7h-118 C132.2,521,121.8,516.6,113,508 M346,203h-41V452h41V203 M227,203h-41V452h41V203z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.292be819.svg";
export { ForwardRef as ReactComponent };